var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0364385 5.52422H21.6629C21.6483 3.30267 21.5384 2.09332 20.7149 1.30194C19.7645 0.388672 18.235 0.388672 15.1759 0.388672H6.52349C3.4644 0.388672 1.93485 0.388672 0.984517 1.30194C0.161007 2.09332 0.0511054 3.30267 0.0364385 5.52422ZM21.6652 7.72273H0.0343057C0.0342637 7.72273 0.0342217 7.72273 0.0341797 7.72273V9.74292C0.0341797 12.6827 0.0341797 14.1526 0.984517 15.0658C1.93485 15.9791 3.46439 15.9791 6.52348 15.9791H6.52349H15.1759H15.1759C18.235 15.9791 19.7645 15.9791 20.7149 15.0658C21.6652 14.1526 21.6652 12.6827 21.6652 9.74292V7.72273ZM5.44206 10.721C4.83496 10.721 4.34281 11.2132 4.34281 11.8203C4.34281 12.4274 4.83496 12.9195 5.44206 12.9195H5.45288C6.05998 12.9195 6.55213 12.4274 6.55213 11.8203C6.55213 11.2132 6.05998 10.721 5.45288 10.721H5.44206Z",
    fill: "#481B3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/Payment.9b8808b842c8a13ee6907ce1131bf573.svg";
export { ForwardRef as ReactComponent };